import {Type} from "class-transformer";
import {serializeType} from "@app/shared/classes/common";

export class WorkAuthorizationLineItem {
  id: number;
  version: number;
  noHourLimit: boolean = false;
  authorizeEntireTeam: boolean = false;
  authorizedHours: number;
  authorizedFrom: string;
  authorizedThru: string;
  authorizedUserId: number;
  authorizedGroupId?: number;
  authorizedMemberId?: number;
  authorizedProjectId?: number;
  authorizedTaskId?: number;
  authorizedResourceId?: number;
  workAuthorizationId?: number;

  // display fields
  authorizedUserName?: string;
  authorizedUserType?: string;
  laborCategory?: string;
  teamName?: string;
  budgetHours?: number;
}


export class WorkAuthorization {
  id: number;
  version?: number;
  allowAllAccess: boolean = false;
  disableAllAccess: boolean = false;
  enableNotification: boolean = false;
  expired?: boolean;

  daysUntilExpiration: number;
  percentHoursThreshold: number;
  @Type(serializeType(WorkAuthorizationLineItem)) workAuthorizationLineitems?: WorkAuthorizationLineItem[];

  chargeCodeId?: number;
  chargeNumber?: string;
  ownerName?: string;
  activityDescription?: string;
  userToNotifyId: number;
  userToNotifyName: string;
}

export enum WorkAuthType {
  Request = 'Request',
  Authorization = 'Authorization'
}

export enum WorkAuthLineType {
  User = 'User',
  Team = 'Team'
}
